import * as React from "react"
const InsertPeakIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 300 300"
    {...props}
  >
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M67.037 223.015q40.956-20.279 49.704-65.212c8.748-44.933 3.09-94.24 18.69-94.24s8.244 49.538 18.688 94.24c9.941 42.547 23.46 64.02 52.09 64.02"
      transform="matrix(1.69364 0 0 1.69364 -66.28 -87.844)"
    />
    <path
      fill="none"
      stroke="#0cb613"
      strokeWidth={15}
      d="M0-53.283V53.283"
      transform="matrix(0 -1 -.79447 0 73.102 89.624)"
    />
    <path
      fill="none"
      stroke="#0cb613"
      strokeWidth={15}
      d="M0-53.283V53.283"
      transform="matrix(-1 0 0 .79447 73.102 89.624)"
    />
  </svg>
)
export default InsertPeakIcon
